import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import GraphNode from "./Node";
import style from "./styles.module.scss";

class Graph extends Component {
  constructor(props) {
    super(props);
    this.handleExpand = this.handleExpand.bind(this);
    this.collapse = this.collapse.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  componentDidMount() {
    const { expandAll, data } = this.props;
    if (expandAll) this.toggleExpand(data, true);
  }

  componentWillUnmount() {}

  handleExpand(e, nodeData) {
    if ("expand" in nodeData) {
      nodeData.expand = !nodeData.expand;
      if (!nodeData.expand && nodeData.children) {
        this.collapse(nodeData.children);
      }
      this.forceUpdate();
    } else {
      nodeData.expand = true;
      this.forceUpdate();
    }
  }

  collapse(list) {
    let _this = this;
    list.forEach(function (child) {
      if (child.expand) {
        child.expand = false;
      }
      child.children && _this.collapse(child.children);
    });
  }

  toggleExpand(data, val) {
    let _this = this;
    if (Array.isArray(data)) {
      data.forEach(function (item) {
        item.expand = val;
        if (item.children) {
          _this.toggleExpand(item.children, val);
        }
      });
    } else {
      data.expand = val;
      if (data.children) {
        _this.toggleExpand(data.children, val);
      }
    }
    this.forceUpdate();
  }

  render() {
    const { horizontal, node, data, selected, onClick } = this.props;
    return (
      <div className={style.treeContainer}>
        <div
          className={classnames([style.tree], {
            [style.horizontal]: horizontal,
          })}
        >
          <GraphNode
            data={data}
            node={node}
            selected={selected}
            onExpand={(e, nodeData) => this.handleExpand(e, nodeData)}
            onClick={(e, nodeData) => onClick && onClick(e, nodeData)}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

Graph.propTypes = {
  data: PropTypes.object,
  selected: PropTypes.any,
  loadingId: PropTypes.any,
  node: PropTypes.object,
  horizontal: PropTypes.bool,
  collapsable: PropTypes.bool,
  expandAll: PropTypes.bool,
  renderContent: PropTypes.func,
  onClick: PropTypes.func,
};

Graph.defaultProps = {
  node: {
    label: "label",
    expand: "expand",
    children: "children",
  },
  renderContent: function (data) {
    return data.label;
  },
};

export default Graph;

export function buildGraphData(data) {
  const graph = {};

  // Verify if the array is not already a map.
  // If it is not, then convert the array to a map.
  if (data && Array.isArray(data)) {
    data.forEach((node) => {
      graph[node.id] = {
        id: node.id,
        label: node.processDescription,
        expand: true,
        data: node,
        parents: node.parentNodes
          ? node.parentNodes.map((parent) => ({
              id: parent.nodeId,
              shortDescription: parent.relationShortDescription,
              longDescription: parent.relationLongDescription,
            }))
          : [],
        children: node.childNodes
          ? node.childNodes.map((child) => ({
              id: child.nodeId,
              shortDescription: child.relationShortDescription,
              longDescription: child.relationLongDescription,
            }))
          : [],
      };
    });
  }

  return graph;
}
